import { render, staticRenderFns } from "./MerchantInfoymm.vue?vue&type=template&id=0ca950c3&scoped=true&"
import script from "./MerchantInfoymm.vue?vue&type=script&lang=js&"
export * from "./MerchantInfoymm.vue?vue&type=script&lang=js&"
import style0 from "./MerchantInfoymm.vue?vue&type=style&index=0&id=0ca950c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca950c3",
  null
  
)

export default component.exports